import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import Radios from '@atoms/Radios';
import CheckboxGroup from '@atoms/CheckboxGroup';
import { ProductsStrings, toCheckboxOrRadioOptions } from '@general/helpers/SavedSearchesQuestionStrings';

const SectionContainer = styled.div`
    margin-bottom: 40px;
`;

export const Products = ({ values }) => (
    <div>
        <SectionContainer>
            <Radios
                label="Are you"
                name="products.areYou"
                value={values.products.areYou}
                instructions="Select one."
                options={toCheckboxOrRadioOptions(ProductsStrings.areYou)}
                required
            />
        </SectionContainer>

        <CheckboxGroup
            label="What type of products or services?"
            name="products.productTypes"
            value={values.products.productTypes}
            instructions="Check all that apply."
            options={toCheckboxOrRadioOptions(ProductsStrings.productTypes)}
            required
        />
    </div>
);

Products.propTypes = {
    values: PropTypes.object,
};
